import { render, staticRenderFns } from "./WidgetPadding.vue?vue&type=template&id=c9071498"
import script from "./WidgetPadding.vue?vue&type=script&lang=js"
export * from "./WidgetPadding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports